import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useFilterStore } from "../AssetVehicle/store/useFilterStore";
import Select from "react-select";
import { GetAllAssociatedTransferStations } from "../../Apis/transferStationApi";
import useIndependentStore from "./store/independentEngineerStore";
import { GetCircle } from "../../Apis/organizationApi";

const IndependentEngineerModal = ({ show, handleClose, selectedEngineerData, canWriteValue }) => {
  const { addNewIndependentEngineer, UpdateIndependentEngineerData, fetchindependentEngineerData } = useIndependentStore();
  const { fetchFilterZones, fetchFilterCircles, zones, circles } = useFilterStore();
  const [associatedTransferStationData, setAssociatedTransferStationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allCircles, setAllCircles] = useState([]);
  const fetchAssociatedTransferStation = async () => {
    try {
      const response = await GetAllAssociatedTransferStations();
      setAssociatedTransferStationData(response);
    } catch (error) {
      console.error("Error fetching transfer stations:", error);
    }
  };

  const fetchAllCircles = async () => {
    try {
      const response = await GetCircle();
      setAllCircles(response);
      console.log(response)
    } catch (error) {
      console.error("Error fetching transfer stations:", error);
    }
  };

  useEffect(() => {
    fetchFilterZones();
    fetchFilterCircles();
    fetchAssociatedTransferStation();
    fetchAllCircles()
  }, []);

  const options = associatedTransferStationData
    .filter((tsData) => tsData.isActive)
    .map((val) => ({
      value: val.transferStationId,
      label: val.transferStationName
    }));

  const initialValues = {
    name: selectedEngineerData?.name || "",
    zone: selectedEngineerData?.zoneId || "",
    circle: selectedEngineerData?.circleId || "",
    contactNumber: selectedEngineerData?.contactNumber || "",
    AssociatedTransferStations: selectedEngineerData?.assocuatedTransferStationIds
      ? selectedEngineerData.assocuatedTransferStationIds.split(",").map(Number) // Convert string to array of numbers
      : [],
    status: selectedEngineerData?.isActive !== undefined ? (selectedEngineerData.isActive ? "active" : "inactive") : "active",
  };


  // Form validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .matches(/^(?!.*\s{2,})[A-Za-z]+(?:\s[A-Za-z]+)*$/, "Only one space between words is allowed")
      .min(3, "Name must be at least 3 characters")
      .max(60, "Name cannot exceed 60 characters")
      .required("Name is required"),
    zone: Yup.string().required("Please select a zone"),

    circle: Yup.string().required("Please select a circle"),

    contactNumber: Yup.string()
      .matches(/^[6-9]/, "Contact number must start with 6, 7, 8, or 9")
      .matches(/^\d{10}$/, "Contact number must be exactly 10 digits long")
      .required("Contact Number is required"),

    AssociatedTransferStations: Yup.array()
      .min(1, "Select at least one transfer station"),

    status: Yup.string().required("Status is required"),
  });



  const handleSubmit = async (values, { resetForm, setErrors }) => {
    const transferStationIds = values.AssociatedTransferStations?.length
      ? values.AssociatedTransferStations.join(",")
      : null;

    try {
      const payload = {
        Name: values.name,
        id: selectedEngineerData?.engineerId || null,
        zoneId: values.zone,
        circleId: values.circle,
        ContactNumber: values.contactNumber,
        AssociatedTransferStations: transferStationIds || selectedEngineerData?.associatedTransferStationIds || "", // ✅ FIXED
        isActive: values.status === "active",
      };

      let result;
      if (selectedEngineerData?.engineerId) {
        setLoading(true)
        // Update existing engineer
        result = await UpdateIndependentEngineerData(payload);
      } else {
        // Add new engineer
        setLoading(true)
        result = await addNewIndependentEngineer(payload);
      }


      if (result.success) {
        resetForm();
        fetchindependentEngineerData();
        handleClose();
        setLoading(false)
      } else if (result.errors) {
        setLoading(false)
        setErrors(result.errors); // Display validation errors from API
      }
    } catch (error) {
      console.error("Submission failed:", error);
      setLoading(false)
      setErrors({ general: "Something went wrong. Please try again." });
    }
  };



  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"

    >
      <Modal.Header>
        <Modal.Title> {selectedEngineerData ? "Edit Independent Engineer" : "Add Independent Engineer"}</Modal.Title>
        <i
          class="fa-solid fa-xmark close-container"
          onClick={handleClose}
        ></i>
      </Modal.Header>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ values, setFieldValue, setFieldTouched }) => (
          <Form>
            <Modal.Body>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">Name<span className="text-danger">*</span></label>
                    <Field type="text" name="name" className="form-control" placeholder="Enter Name"
                      onChange={(e) => {
                        const { value } = e.target;
                        setFieldValue("name",
                          value
                            .replace(/[^a-zA-Z\s]/g, "") // Allows only alphabets and spaces
                            .replace(/^\s+/, "") // Trims leading spaces
                            .replace(/\s{2,}/g, " ") // Replaces multiple spaces with a single space
                        );
                      }} />
                    <ErrorMessage name="name" component="div" className="text-danger mt-1 small" />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">Zone <span className="text-danger">*</span></label>
                    <Field
                      as="select"
                      name="zone"
                      className="form-select"
                      onChange={(e) => {
                        const selectedZone = e.target.value;

                        setFieldValue("zone", selectedZone);
                        setFieldTouched("zone", false);
                        setFieldValue("circle", "");

                        // if (selectedZone) {
                        //   fetchFilterCircles(selectedZone); // Fetch circles based on the selected zone
                        // }
                      }}
                    >
                      <option value="">Select Zone</option>
                      {zones
                      .filter((zone) => zone.isActive)
                      .map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                    </Field>

                    <ErrorMessage name="zone" component="div" className="text-danger mt-1 small" />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="CircleId" className="form-label">Circle<span className="text-danger">*</span></label>
                    <Field
                      as="select"
                      name="circle"
                      id="CircleId"
                      className="form-select"
                      disabled={!values.zone}
                    >
                      <option value="">Select Circle</option>
                      {allCircles.length > 0 ? (
                        allCircles
                          .filter((circle) => circle.isActive && circle.zoneId == values.zone)
                          .map((circle) => (
                            <option key={circle.circleId} value={circle.circleId}>
                              {circle.circleName}
                            </option>
                          ))
                      ) : (
                        <option value="">No Circles Found</option>
                      )}

                    </Field>

                    <ErrorMessage name="circle" component="div" className="text-danger mt-1 small" />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">Contact Number<span className="text-danger">*</span></label>
                    <Field type="text" name="contactNumber" className="form-control" placeholder="Enter Contact Number"
                      onChange={(e) => {
                        let { value } = e.target;
                        value = value.replace(/\D/g, "");
                        value = value.replace(/^0+/, "");
                        if (value.length > 10) value = value.slice(0, 10);
                        if (!/^[6-9]/.test(value) && value.length > 0) value = "";
                        setFieldValue("contactNumber", value);
                      }}
                    />
                    <ErrorMessage name="contactNumber" component="div" className="text-danger mt-1 small" />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label className="form-label">
                      Associated Transfer Station {" "}
                      <span style={{ color: "#EC1117" }}> *</span>
                    </label>
                    <div className="select-container">
                      <Select
                        classNamePrefix="CreatableSelect"
                        id="AssociatedTransferStations"
                        name="AssociatedTransferStations"
                        isMulti
                        options={options}
                        value={options.filter(option => values.AssociatedTransferStations.includes(option.value))} // ✅ Keeps selected values
                        onChange={(selectedOptions) => {
                          const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
                          setFieldValue("AssociatedTransferStations", selectedValues);
                        }}
                      />
                    </div>
                    <ErrorMessage name="AssociatedTransferStations" component="div" className="text-danger mt-1 small" />
                  </div>
                </div>

              </div>
              <div className="mb-3 form-group">
                <label className="form-label">Status</label>
                <div className="d-flex align-items-center gap-3">
                  <label className="d-flex align-items-center">
                    <Field type="radio" name="status" value="active" className="me-1" />
                    Active
                  </label>

                  <label className="d-flex align-items-center">
                    <Field type="radio" name="status" value="inactive" className="me-1" />
                    InActive
                  </label>
                </div>
                <ErrorMessage name="status" component="div" className="text-danger mt-1" />
              </div>
            </Modal.Body>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true &&
                <button type="submit" className="deployment-button">
                  {selectedEngineerData ?
                    loading ?
                      <l-bouncy
                        size="25"
                        speed="1.75"
                        color="white"
                      ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Update</> :
                    loading ? <l-bouncy
                      size="25"
                      speed="1.75"
                      color="white"
                    ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Submit </>}
                </button>}
            </div>

          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default IndependentEngineerModal;
